import React, {useState} from "react";
import FooterLayout from "../../layouts/FooterLayout";
import {Button, Card, Col, DatePicker, Form, Input, notification, Row, Select} from "antd";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowLeft, faLocationArrow} from "@fortawesome/free-solid-svg-icons";
import {AddRequest} from "../../services/request";
import Cookies from "js-cookie";
import ModalReCapcha from "../../components/ModelReCapcha";

const listGioiTinhs = [
  {
    id: 'Nam',
    ten: 'Nam',
  },
  {
    id: 'Nữ',
    ten: 'Nữ',
  },
  {
    id: 'Khác',
    ten: 'Khác',
  },
];

function RequestDiploma() {
  const [form] = Form.useForm();

  const objectValidateForm = {
    checkString: (maxLength, checkEmpty, nameLabel) => ({
      maxLength,
      checkEmpty,
      nameLabel,
    }),
    checkNumber: (minValue, maxValue, nameLabel, checkEmpty, maxLength) => ({
      type: "number",
      checkEmpty,
      minValue,
      maxValue,
      nameLabel,
      maxLength,
    }),
  };

  const paserValue = (value) => {
    return `${value}`.replace(/\$\s?|(,*)/g, "");
  };

  const handleValidateFields = (rule, value, objectValidate) => {
    if (objectValidate.checkEmpty && !value) {
      if (value !== 0) {
        return Promise.reject(
          `${objectValidate.nameLabel} không được để trống`
        );
      }
    }

    if (!objectValidate.checkEmpty && !value) {
      return Promise.resolve();
    }

    if (!value) {
      if (value === 0) {
        return Promise.resolve();
      } else {
        return Promise.reject();
      }
    }

    const valueParser = paserValue(`${value}`);
    if (
      objectValidate.type === "number" &&
      (valueParser === "-" || valueParser === ".")
    ) {
      return Promise.reject(
        `${objectValidate.nameLabel} không phải số`
      );
    }
    if (
      objectValidate.type === "number" &&
      !RegExp("^[+-]?([0-9]*[.])?[0-9]+$").test(valueParser)
    ) {
      if (Number(Math.ceil(valueParser)) !== Number(valueParser)) {
        return Promise.reject(
          `${objectValidate.nameLabel} không phải số`
        );
      }
    }
    if (
      objectValidate.minValue !== null &&
      valueParser < objectValidate.minValue
    ) {
      return Promise.reject(
        `${objectValidate.nameLabel} lớn hơn ${
          objectValidate.minValue
        }.`
      );
    }
    if (
      objectValidate.maxValue !== null &&
      Number(valueParser) * 100 > objectValidate.maxValue * 100
    ) {
      return Promise.reject(
        `${objectValidate.nameLabel} nhỏ hơn ${
          objectValidate.maxValue
        }.`
      );
    }
    if (
      objectValidate.minLength !== null &&
      [...valueParser].length < objectValidate.minLength
    ) {
      return Promise.reject(
        `${objectValidate.nameLabel} tối thiểu ${
          objectValidate.minLength
        } ký tự`
      );
    }
    if (
      objectValidate.maxLength !== null &&
      [...valueParser].length > objectValidate.maxLength
    ) {
      return Promise.reject(
        `${objectValidate.nameLabel} tối đa ${
          objectValidate.maxLength
        } ký tự`
      );
    }
    if (
      objectValidate.checkDuplicate &&
      objectValidate.arrayDuplicate.includes(valueParser.toLowerCase().trim())
    ) {
      if (valueParser.toLowerCase() !== objectValidate.authCodeOld) {
        return Promise.reject(
          `${objectValidate.nameLabel} đã tồn tại`
        );
      }
    }
    return Promise.resolve();
  };

  const [loading, setLoading] = useState(false);

  const [isModalVisible, setIsModalVisible] = useState(false);

  const handleRequestCopy = async (fieldsValue) => {
    if (!Cookies.get("code")) {
      setIsModalVisible(true);
    } else {
      setLoading(true);

      try {
        const payload = {
          ...fieldsValue,
          trangThaiYeuCauId: 1,
        }

        const res = await AddRequest(payload);

        if (res) {
          notification.success({
            message: "Thành công",
            description: "Gửi yêu cầu cấp bản sao thành công",
          });

          form.resetFields();
          setLoading(false);
        }
      } catch (error) {
        notification.error({
          message: "Lỗi ",
          description: "Có lỗi xảy ra vui lòng thử lại",
        });
        setLoading(false);
      }
    }
  }

  const handleCanncel = () => {
    window.location.href = '/';
  }

  return (
    <>
      <div className="container wrap-request">
        <div className="text-center my-4 text-header-request">
          Yêu cầu cấp bản sao
        </div>
        <Form
          id="form-add-student-management"
          form={form}
          onFinish={handleRequestCopy}
        >
          <Row gutter={[16, 16]}>
            <Col span={16} md={16}>
              <Card
                style={{
                  borderRadius: 8,
                  boxShadow: "0 1px 6px 0 rgba(0,0,0,.16)",
                }}
              >
                <div
                  style={{
                    backgroundColor: "#E6F7FF",
                    borderBottom: "1px solid #fff",
                    padding: "4px 8px",
                    // color: '#5f6368',
                    color: '#4a81d4',
                  }}
                  className="mb-3"
                >
                  <span style={{ fontSize: 16, fontWeight: 600 }}>
                    Thông tin học viên
                  </span>
                </div>

                <Row gutter={[16, 16]}>
                  <Col span={12} md={12}>
                    <div>
                      <span style={{ fontWeight: 600, fontSize: "14px" }}>
                        {"Số định danh"}
                      </span>
                      <span style={{ paddingLeft: "3px", color: "red" }}>*</span>
                    </div>
                    <Form.Item
                      name={"soDinhDanh"}
                      className="mb-0"
                      rules={[
                        {
                          validator(rule, value) {
                            return handleValidateFields(
                              rule,
                              value,
                              objectValidateForm.checkString(50, true, "Số định danh"),
                            );
                          },
                        },
                      ]}
                    >
                      <Input placeholder="Số định danh" />
                    </Form.Item>
                  </Col>

                  <Col span={12} md={12}>
                    <div>
                      <span style={{ fontWeight: 600, fontSize: "14px" }}>
                        {"Số CMND/CCCD"}
                      </span>
                      <span style={{ paddingLeft: "3px", color: "red" }}>*</span>
                    </div>
                    <Form.Item
                      name={"soCMND"}
                      className="mb-0"
                      rules={[
                        {
                          validator(rule, value) {
                            return handleValidateFields(
                              rule,
                              value,
                              objectValidateForm.checkString(20, true, "Số CMND/CCCD"),
                            );
                          },
                        },
                      ]}
                    >
                      <Input placeholder="Số CMND/CCCD" />
                    </Form.Item>
                  </Col>

                  <Col span={12} md={12}>
                    <div>
                      <span style={{ fontWeight: 600, fontSize: "14px" }}>
                        {"Họ và tên"}
                      </span>
                      <span style={{ paddingLeft: "3px", color: "red" }}>*</span>
                    </div>
                    <Form.Item
                      name={"hoTenNguoiCapBang"}
                      className="mb-0"
                      rules={[
                        {
                          validator(rule, value) {
                            return handleValidateFields(
                              rule,
                              value,
                              objectValidateForm.checkString(255, true, "Họ và tên"),
                            );
                          },
                        },
                      ]}
                    >
                      <Input placeholder="Nhập họ và tên" />
                    </Form.Item>
                  </Col>

                  <Col span={12} md={12}>
                    <div>
                      <span style={{ fontWeight: 600, fontSize: "14px" }}>
                        {"Giới tính"}
                      </span>
                      <span style={{ paddingLeft: "3px", color: "red" }}>*</span>
                    </div>
                    <Form.Item
                      name={"gioiTinh"}
                      className="mb-0"
                      rules={[
                        {
                          required: true,
                          message: `Giới tính không được để trống`,
                        },
                      ]}
                    >
                      <Select placeholder="Chọn giới tính">
                        {listGioiTinhs.map((value, index) => (
                          <Select.Option value={value.id} key={index}>
                            {value.ten}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>

                  <Col span={12} md={12}>
                    <div>
                      <span style={{ fontWeight: 600, fontSize: "14px" }}>
                        {"Dân tộc"}
                      </span>
                      <span style={{ paddingLeft: "3px", color: "red" }}>*</span>
                    </div>
                    <Form.Item
                      name={"danToc"}
                      className="mb-0"
                      rules={[
                        {
                          required: true,
                          message: `${"Dân tộc không được để trống!"}`,
                        },
                      ]}
                    >
                      <Input placeholder="Dân tộc" />
                    </Form.Item>
                  </Col>

                  <Col span={12} md={12}>
                    <div>
                      <span style={{ fontWeight: 600, fontSize: "14px" }}>
                        {"Tôn giáo"}
                      </span>
                      <span style={{ paddingLeft: "3px", color: "red" }}>*</span>
                    </div>
                    <Form.Item
                      name={"tonGiao"}
                      className="mb-0"
                      rules={[
                        {
                          validator(rule, value) {
                            return handleValidateFields(
                              rule,
                              value,
                              objectValidateForm.checkString(50, true, "Tôn giáo"),
                            );
                          },
                        },
                      ]}
                    >
                      <Input placeholder="Tôn giáo" />
                    </Form.Item>
                  </Col>

                  <Col span={12} md={12}>
                    <div>
                      <span style={{ fontWeight: 600, fontSize: "14px" }}>
                        {"Tình trạng hôn nhân"}
                      </span>
                      <span style={{ paddingLeft: "3px", color: "red" }}>*</span>
                    </div>
                    <Form.Item
                      name={"tinhTrangHonNhan"}
                      className="mb-0"
                      rules={[
                        {
                          validator(rule, value) {
                            return handleValidateFields(
                              rule,
                              value,
                              objectValidateForm.checkString(50, true, "Tình trạng hôn nhân"),
                            );
                          },
                        },
                      ]}
                    >
                      <Input placeholder="Tình trạng hôn nhân" />
                    </Form.Item>
                  </Col>

                  <Col span={12} md={12}>
                    <div>
                      <span style={{ fontWeight: 600, fontSize: "14px" }}>
                        {"Ngày sinh"}
                      </span>
                      <span style={{ paddingLeft: "3px", color: "red" }}>*</span>
                    </div>
                    <Form.Item
                      name={"ngaySinh"}
                      className="mb-0"
                      rules={[
                        {
                          required: true,
                          message: `${"Ngày sinh không được để trống"}`,
                        },
                      ]}
                    >
                      <DatePicker
                        format="DD/MM/YYYY"
                        style={{ width: "100%" }}
                        inputReadOnly={true}
                        placeholder="Chọn ngày sinh"
                      />
                    </Form.Item>
                  </Col>

                  <Col span={12} md={12}>
                    <div>
                      <span style={{ fontWeight: 600, fontSize: "14px" }}>
                        {"Nơi đăng ký khai sinh"}
                      </span>
                      <span style={{ paddingLeft: "3px", color: "red" }}>*</span>
                    </div>
                    <Form.Item
                      name={"noiDangKyKhaiSinh"}
                      className="mb-0"
                      rules={[
                        {
                          validator(rule, value) {
                            return handleValidateFields(
                              rule,
                              value,
                              objectValidateForm.checkString(255, true, "Nơi đăng ký khai sinh"),
                            );
                          },
                        },
                      ]}
                    >
                      <Input placeholder="Nhập nơi đăng ký khai sinh" />
                    </Form.Item>
                  </Col>

                  <Col span={12} md={12}>
                    <div>
                      <span style={{ fontWeight: 600, fontSize: "14px" }}>
                        {"Quê quán"}
                      </span>
                      <span style={{ paddingLeft: "3px", color: "red" }}>*</span>
                    </div>
                    <Form.Item
                      name={"queQuan"}
                      className="mb-0"
                      rules={[
                        {
                          validator(rule, value) {
                            return handleValidateFields(
                              rule,
                              value,
                              objectValidateForm.checkString(255, true, "Quê quán"),
                            );
                          },
                        },
                      ]}
                    >
                      <Input placeholder="Nhập quê quán" />
                    </Form.Item>
                  </Col>

                  <Col span={12} md={12}>
                    <div>
                      <span style={{ fontWeight: 600, fontSize: "14px" }}>
                        {"Hộ khẩu thường trú"}
                      </span>
                      <span style={{ paddingLeft: "3px", color: "red" }}>*</span>
                    </div>
                    <Form.Item
                      name={"hktt"}
                      className="mb-0"
                      rules={[
                        {
                          validator(rule, value) {
                            return handleValidateFields(
                              rule,
                              value,
                              objectValidateForm.checkString(
                                255,
                                true,
                                "Hộ khẩu thường trú"
                              ),
                            );
                          },
                        },
                      ]}
                    >
                      <Input placeholder="Nhập hộ khẩu thường trú" />
                    </Form.Item>
                  </Col>

                  <Col span={12} md={12}>
                    <div>
                      <span style={{ fontWeight: 600, fontSize: "14px" }}>
                        {"Nơi ở hiện tại"}
                      </span>
                      <span style={{ paddingLeft: "3px", color: "red" }}>*</span>
                    </div>
                    <Form.Item
                      name={"noiOHienTai"}
                      className="mb-0"
                      rules={[
                        {
                          validator(rule, value) {
                            return handleValidateFields(
                              rule,
                              value,
                              objectValidateForm.checkString(
                                255,
                                true,
                                "Nơi ở hiện tại"
                              ),
                            );
                          },
                        },
                      ]}
                    >
                      <Input placeholder="Nhập nơi ở hiện tại" />
                    </Form.Item>
                  </Col>

                  <Col span={12} md={12}>
                    <div>
                      <span style={{ fontWeight: 600, fontSize: "14px" }}>
                        {"Cha"}
                      </span>
                      {/*<span style={{ paddingLeft: "3px", color: "red" }}>*</span>*/}
                    </div>
                    <Form.Item
                      name={"hoTenCha"}
                      className="mb-0"
                      rules={[
                        {
                          validator(rule, value) {
                            return handleValidateFields(
                              rule,
                              value,
                              objectValidateForm.checkString(
                                255,
                                false,
                                "Họ và tên cha"
                              ),
                            );
                          },
                        },
                      ]}
                    >
                      <Input placeholder="Nhập họ và tên cha" />
                    </Form.Item>
                  </Col>

                  <Col span={12} md={12}>
                    <div>
                      <span style={{ fontWeight: 600, fontSize: "14px" }}>
                        {"Mẹ"}
                      </span>
                      {/*<span style={{ paddingLeft: "3px", color: "red" }}>*</span>*/}
                    </div>
                    <Form.Item
                      name={"hoTenMe"}
                      className="mb-0"
                      rules={[
                        {
                          validator(rule, value) {
                            return handleValidateFields(
                              rule,
                              value,
                              objectValidateForm.checkString(
                                255,
                                false,
                                "Họ và tên mẹ"
                              ),
                            );
                          },
                        },
                      ]}
                    >
                      <Input placeholder="Nhập họ và tên mẹ" />
                    </Form.Item>
                  </Col>

                  <Col span={12} md={12}>
                    <div>
                      <span style={{ fontWeight: 600, fontSize: "14px" }}>
                        {"Quốc tịch"}
                      </span>
                      <span style={{ paddingLeft: "3px", color: "red" }}>*</span>
                    </div>
                    <Form.Item
                      name={"quocTich"}
                      className="mb-0"
                      rules={[
                        {
                          validator(rule, value) {
                            return handleValidateFields(
                              rule,
                              value,
                              objectValidateForm.checkString(
                                255,
                                true,
                                "Quốc tịch"
                              ),
                            );
                          },
                        },
                      ]}
                    >
                      <Input placeholder="Nhập quốc tịch" />
                    </Form.Item>
                  </Col>

                  <Col span={12} md={12}>
                    <div>
                      <span style={{ fontWeight: 600, fontSize: "14px" }}>
                        {"Năm tốt nghiệp"}
                      </span>
                      <span style={{ paddingLeft: "3px", color: "red" }}>*</span>
                    </div>
                    <Form.Item
                      name={"namTotNghiep"}
                      className="mb-0"
                      rules={[
                        {
                          validator(rule, value) {
                            return handleValidateFields(
                              rule,
                              value,
                              objectValidateForm.checkNumber(
                                0,
                                null,
                                "Năm tốt nghiệp",
                                true,
                                4
                              ),
                            );
                          },
                        },
                      ]}
                    >
                      <Input placeholder="Nhập năm tốt nghiệp" />
                    </Form.Item>
                  </Col>

                  <Col span={12} md={12}>
                    <div>
                      <span style={{ fontWeight: 600, fontSize: "14px" }}>
                        {"Hình thức đào tạo"}
                      </span>
                      <span style={{ paddingLeft: "3px", color: "red" }}>*</span>
                    </div>
                    <Form.Item
                      name={"hinhThucDaoTao"}
                      className="mb-0"
                      rules={[
                        {
                          validator(rule, value) {
                            return handleValidateFields(
                              rule,
                              value,
                              objectValidateForm.checkString(
                                100,
                                true,
                                "Hình thức đào tạo"
                              ),
                            );
                          },
                        },
                      ]}
                    >
                      <Input placeholder="Nhập hình thức đào tạo" />
                    </Form.Item>
                  </Col>

                  <Col span={12} md={12}>
                    <div>
                      <span style={{ fontWeight: 600, fontSize: "14px" }}>
                        {"Lớp"}
                      </span>
                      <span style={{ paddingLeft: "3px", color: "red" }}>*</span>
                    </div>
                    <Form.Item
                      name={"lop"}
                      className="mb-0"
                      rules={[
                        {
                          validator(rule, value) {
                            return handleValidateFields(
                              rule,
                              value,
                              objectValidateForm.checkString(
                                50,
                                true,
                                "Lớp"
                              ),
                            );
                          },
                        },
                      ]}
                    >
                      <Input placeholder="Lớp" />
                    </Form.Item>
                  </Col>

                  <Col span={12} md={12}>
                    <div>
                      <span style={{ fontWeight: 600, fontSize: "14px" }}>
                        {"Loại bằng"}
                      </span>
                      <span style={{ paddingLeft: "3px", color: "red" }}>*</span>
                    </div>
                    <Form.Item
                      name={"loaiBang"}
                      className="mb-0"
                      rules={[
                        {
                          validator(rule, value) {
                            return handleValidateFields(
                              rule,
                              value,
                              objectValidateForm.checkString(
                                100,
                                true,
                                "Loại bằng"
                              ),
                            );
                          },
                        },
                      ]}
                    >
                      <Input placeholder="Loại bằng" />
                    </Form.Item>
                  </Col>
                </Row>
              </Card>
            </Col>

            <Col span={8} md={8}>
              <Card style={{
                height: '100%',
                borderRadius: 8,
                boxShadow: "0 1px 6px 0 rgba(0,0,0,.16)",
              }}>
                <div
                  style={{
                    backgroundColor: "#E6F7FF",
                    borderBottom: "1px solid #fff",
                    padding: "4px 8px",
                    // color: '#5f6368',
                    color: '#4a81d4',
                  }}
                  className="mb-3"
                >
                  <span style={{ fontSize: 16, fontWeight: 600 }}>
                    Thông tin người yêu cầu
                  </span>
                </div>

                <Row gutter={[16, 16]}>
                  <Col span={24} md={24}>
                    <div>
                      <span style={{ fontWeight: 600, fontSize: "14px" }}>
                        {"Họ tên người yêu cầu"}
                      </span>
                      <span style={{ paddingLeft: "3px", color: "red" }}>*</span>
                    </div>
                    <Form.Item
                      name={"tenNguoiYeuCau"}
                      className="mb-0"
                      rules={[
                        {
                          validator(rule, value) {
                            return handleValidateFields(
                              rule,
                              value,
                              objectValidateForm.checkString(255, true, "Họ tên người yêu cầu"),
                            );
                          },
                        },
                      ]}
                    >
                      <Input placeholder="Họ tên người yêu cầu" />
                    </Form.Item>
                  </Col>

                  <Col span={24} md={24}>
                    <div>
                      <span style={{ fontWeight: 600, fontSize: "14px" }}>
                        {"Quan hệ với người cần cấp bằng"}
                      </span>
                      <span style={{ paddingLeft: "3px", color: "red" }}>*</span>
                    </div>
                    <Form.Item
                      name={"quanHeVoiNguoiCanCapBang"}
                      className="mb-0"
                      rules={[
                        {
                          validator(rule, value) {
                            return handleValidateFields(
                              rule,
                              value,
                              objectValidateForm.checkString(50, true, "Quan hệ với người cấp bằng"),
                            );
                          },
                        },
                      ]}
                    >
                      <Input placeholder="Bố/mẹ" />
                    </Form.Item>
                  </Col>

                  <Col span={24} md={24}>
                    <div>
                      <span style={{ fontWeight: 600, fontSize: "14px" }}>
                        {"Số CCCD/CMND người đăng ký"}
                      </span>
                      <span style={{ paddingLeft: "3px", color: "red" }}>*</span>
                    </div>
                    <Form.Item
                      name={"soCMNDNguoiDangKy"}
                      className="mb-0"
                      rules={[
                        {
                          validator(rule, value) {
                            return handleValidateFields(
                              rule,
                              value,
                              objectValidateForm.checkString(20, true, "Số CCCD/CMND"),
                            );
                          },
                        },
                      ]}
                    >
                      <Input placeholder="Số CCCD/CMND" />
                    </Form.Item>
                  </Col>

                  <Col span={24} md={24}>
                    <div>
                      <span style={{ fontWeight: 600, fontSize: "14px" }}>
                        {"Số điện thoại người đăng ký"}
                      </span>
                      <span style={{ paddingLeft: "3px", color: "red" }}>*</span>
                    </div>
                    <Form.Item
                      name={"dienThoaiNguoiDangKy"}
                      className="mb-0"
                      rules={[
                        {
                          validator(rule, value) {
                            return handleValidateFields(
                              rule,
                              value,
                              objectValidateForm.checkString(20, true, "Số điện thoại"),
                            );
                          },
                        },
                      ]}
                    >
                      <Input placeholder="0987654321" />
                    </Form.Item>
                  </Col>

                  <Col span={24} md={24}>
                    <div>
                      <span style={{ fontWeight: 600, fontSize: "14px" }}>
                        {"Địa chỉ người đăng ký"}
                      </span>
                      <span style={{ paddingLeft: "3px", color: "red" }}>*</span>
                    </div>
                    <Form.Item
                      name={"diaChiNguoiDangKy"}
                      className="mb-0"
                      rules={[
                        {
                          validator(rule, value) {
                            return handleValidateFields(
                              rule,
                              value,
                              objectValidateForm.checkString(20, true, "Địa chỉ người đăng ký"),
                            );
                          },
                        },
                      ]}
                    >
                      <Input placeholder="Địa chỉ người đăng ký" />
                    </Form.Item>
                  </Col>
                </Row>
              </Card>
            </Col>
          </Row>
          <div className="text-center mt-4">
            <Button
              onClick={handleCanncel}
              style={{ marginRight: 8 }}
              icon={
                <FontAwesomeIcon
                  icon={faArrowLeft}
                  className="mr-2"
                />
              }
            >
              Quay lại
            </Button>
            <Button
              type="primary"
              htmlType="submit"
              key="submit"
              form="form-add-student-management"
              loading={loading}
              icon={
                <FontAwesomeIcon
                  icon={faLocationArrow}
                  className="mr-2"
                />
              }
            >
              Gửi yêu cầu
            </Button>
          </div>
        </Form>
      </div>

      {isModalVisible && (
        <ModalReCapcha
          setIsModalVisible={setIsModalVisible}
          isModalVisible={isModalVisible}
        />
      )}

      {/*<FooterLayout />*/}
    </>
  )
};

export default RequestDiploma;
